"use client";

import { useEffect, useState } from "react";

/**
 * True once the page has loaded and the main thread has gone idle; stays
 * true. Overlays (cart drawer, search, quick view, promo, PWA banners) fetch
 * their code on it: after the page is usable, so it never competes with the
 * first paint, yet before the first tap in practice.
 */
export function usePageIdle(): boolean {
  const [idle, setIdle] = useState(false);

  useEffect(() => {
    let idleHandle: number | undefined;
    let timeout: number | undefined;
    const onIdle = () => setIdle(true);
    const schedule = () => {
      // Safari has no requestIdleCallback; after `load` a macrotask is the
      // closest equivalent.
      if (typeof window.requestIdleCallback === "function") {
        idleHandle = window.requestIdleCallback(onIdle);
      } else {
        timeout = window.setTimeout(onIdle, 0);
      }
    };
    if (document.readyState === "complete") schedule();
    else window.addEventListener("load", schedule, { once: true });
    return () => {
      window.removeEventListener("load", schedule);
      if (idleHandle !== undefined) window.cancelIdleCallback(idleHandle);
      if (timeout !== undefined) window.clearTimeout(timeout);
    };
  }, []);

  return idle;
}
